module.exports = __webpack_public_path__ + "ba4e7809d474b7b6936d09346695c3ae.woff";